import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { LoggerService } from 'src/app/services/logger.service';
import { IDashboardOperation } from '../../models/operation.model';
import { FALSY_VALUES, ITableEvent, ITableKey } from './basic-table.constants';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { IObjectKey } from '../../models/objects';

@Component({
  selector: 'app-basic-table',
  templateUrl: './basic-table.component.html',
  styleUrl: './basic-table.component.scss',
})
export class BasicTableComponent implements OnInit, OnChanges {

  @Input() dataset;
  @Input() tableKeys: ITableKey[] = [];

  @Output() actionRequested = new EventEmitter<ITableEvent<any>>();
  @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();

  radioSelectionGroup: string = null;

  ngOnInit() {
    this.radioSelectionGroup = this.dataset && this.dataset.length > 0 ? this.dataset.find(item => item.selected)?.fundCode : null;
  }

  ngOnChanges() {
    console.dir(this.dataset, { depth: null });
  }

  onButtonClick(element: any, formKey: ITableKey) {
    const obj: ITableEvent<any> = {
      element: element,
      action: formKey.key
    }
    LoggerService.logInfo(this.constructor.name, 'onButtonClick', { obj });
    this.actionRequested.emit(obj);
  }

  getCompanyImage(item: IDashboardOperation): string {
    if (item && item.companyId) {
      return CommonUtils.getCompanyImage(item.companyId);
    }
    return '';
  }

  getOperationStatusLabel(item: IDashboardOperation): string {
    return CommonUtils.getStatusLabel(item);
  }

  getStatusBadge(item: IDashboardOperation): string {
    return CommonUtils.getStatusBadge(item);
  }

  getGenericStatusColor(item: any, elem: ITableKey): string {
    return FALSY_VALUES.includes(item[elem.key]) ? 'badge-red' : 'badge-green';
  }

  getGenericStatusLabel(item: any, elem: ITableKey): string {
    return elem.defaultValue || item[elem.key] || '';
  }

  getValue(item: any, key: IObjectKey): string {
    const value = CommonUtils.getValueByPath(item, key);
    return value;
  }

  selectItem(element: any) {
    LoggerService.logInfo(this.constructor.name, 'selectItem', { element });
    this.radioSelectionGroup = element.fundCode;
    this.itemSelected.emit(element);
  }


}
